__turbopack_context__.v({
  "clearIndicator": "FormSelect-module-scss-module__Miw_eG__clearIndicator",
  "error": "FormSelect-module-scss-module__Miw_eG__error",
  "errorMsg": "FormSelect-module-scss-module__Miw_eG__errorMsg",
  "field": "FormSelect-module-scss-module__Miw_eG__field",
  "fieldDescription": "FormSelect-module-scss-module__Miw_eG__fieldDescription",
  "icon": "FormSelect-module-scss-module__Miw_eG__icon",
  "input": "FormSelect-module-scss-module__Miw_eG__input",
  "label": "FormSelect-module-scss-module__Miw_eG__label",
  "notFound": "FormSelect-module-scss-module__Miw_eG__notFound",
  "notFoundContent": "FormSelect-module-scss-module__Miw_eG__notFoundContent",
  "option": "FormSelect-module-scss-module__Miw_eG__option",
  "optionDesc": "FormSelect-module-scss-module__Miw_eG__optionDesc",
  "optionLabel": "FormSelect-module-scss-module__Miw_eG__optionLabel",
  "required": "FormSelect-module-scss-module__Miw_eG__required",
  "sticky": "FormSelect-module-scss-module__Miw_eG__sticky",
});
